const STORAGE_KEY = 'wollzy_consent_mailings';

export function storeConsentMailings(accepted) {
  if (typeof window === 'undefined') {
    return;
  }
  const value = accepted ? '1' : '0';
  try {
    window.sessionStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    // ignore quota / private mode
  }
  window.__WOLLZY_CONSENT_MAILINGS__ = Boolean(accepted);
}

export function readConsentMailings() {
  if (typeof window === 'undefined') {
    return false;
  }
  if (typeof window.__WOLLZY_CONSENT_MAILINGS__ === 'boolean') {
    return window.__WOLLZY_CONSENT_MAILINGS__;
  }
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
}
